import { Route, Redirect } from "react-router-dom";

const PublicRoute = ({ component: Component, isAuthenticated, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            (!isAuthenticated
                ? <Component {...props} />
                : <Redirect
                    to={{
                    pathname: "/users",
                    state: { from: props.location }
                }} />
            )
         } />
);

export default PublicRoute;
